import { render } from "./SummaryItemList.vue?vue&type=template&id=b21f8e8a&scoped=true"
import script from "./SummaryItemList.vue?vue&type=script&lang=js"
export * from "./SummaryItemList.vue?vue&type=script&lang=js"

import "./SummaryItemList.vue?vue&type=style&index=0&id=b21f8e8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b21f8e8a"

export default script